import { jsx as _jsx } from "react/jsx-runtime";
import '../styles/tailwind.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import async from 'async';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MidnightRefresh from './utils/MidnightRefresh';
import CompanyStore from './stores/CompanyStore/store';
import ClientStateStore from './stores/ClientStateStore/store';
import FeatureFlagStore from './stores/FeatureFlagStore/store';
import API from './utils/WebAPIUtils';
import Mobile from './components/mobile/Mobile';
import ErrorBoundary from './components/shared/ErrorBoundary';
import initializeFeatureFlags, { flagSettingsFrom } from './utils/FeatureFlags';
import { fetchGame, setupRealtimeSubscriptions } from './utils/DataUtils';
import { initPusher } from './services/pusher';
import { markEnteredThroughMobile } from './utils/MobileEntry';
window.React = React; // export for http://fb.me/react-devtools
// SCO-583: the website's setup pop-down never shows in a tab that came in
// through these pages (the phone app's tabs all do).
markEnteredThroughMobile();
// Track root instance to prevent multiple createRoot calls (for HMR)
var rootInstance = null;
var renderRoutes = function () {
    // Render app
    var rootElement = document.getElementById('main');
    if (!rootElement) {
        console.error('Root element not found');
        return;
    }
    // Only create root once, reuse on HMR or multiple calls
    if (!rootInstance) {
        rootInstance = createRoot(rootElement);
    }
    rootInstance.render(_jsx(ErrorBoundary, { children: _jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsx(Route, { path: "/mobile/*", element: _jsx(Mobile, {}) }) }) }) }));
};
var initData = function (result) {
    CompanyStore.init(result);
    ClientStateStore.init({ loggedIn: true });
    // No analytics on this bundle (James, 2026-10-11: flags only here; no
    // session recording, no autocapture, no person profile). The analytics SDK
    // is never initialised, identified or grouped from this entry point,
    // whatever shape the payload has. The flag request below is the only thing
    // this bundle sends to PostHog.
    var currentUser = CompanyStore.getCurrentUser();
    if (currentUser) {
        // Feature flags (PostHog, SCO-818): one request for this user and office.
        // The fetched data carries the settings at the top level; they are read
        // from either place.
        initializeFeatureFlags(flagSettingsFrom(result), currentUser, FeatureFlagStore.updateFlags.bind(FeatureFlagStore));
    }
    // Begin data syncing
    async.each(result.games_list.all, fetchGame, function () {
        var _a;
        console.log('DO YOU SEE ME?');
        setupRealtimeSubscriptions(result.sbb_pusher_key || ((_a = result.app_settings) === null || _a === void 0 ? void 0 : _a.sbb_pusher_key) || '');
    });
};
window.initData = initData;
API.fetchApplicationData(function (error, result) {
    if (!error && result) {
        initData(result);
        renderRoutes();
        return;
    }
    API.getAppSettings(function (err, res) {
        if (err) {
            console.log('Error getting app settings: ', err);
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var settings = res;
        if (!settings || !settings.sbb_pusher_key) {
            console.log('No Pusher key found in app settings');
            return;
        }
        // Initialize CompanyStore with app_settings so getApiEndpoint() returns
        // the correct environment-specific endpoint (e.g., api.sbbdev.com in local dev)
        CompanyStore.init({ app_settings: settings });
        initPusher(settings.sbb_pusher_key);
        renderRoutes();
    });
});
// Setup midnight refresh
MidnightRefresh();
